import { render, staticRenderFns } from "./GroupModalWithButton.vue?vue&type=template&id=46f541e2"
import script from "./GroupModalWithButton.vue?vue&type=script&lang=ts"
export * from "./GroupModalWithButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f541e2')) {
      api.createRecord('46f541e2', component.options)
    } else {
      api.reload('46f541e2', component.options)
    }
    module.hot.accept("./GroupModalWithButton.vue?vue&type=template&id=46f541e2", function () {
      api.rerender('46f541e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupModalWithButton.vue"
export default component.exports